<template>
  <div>
    <ColorBanner />
    <v-container>
      <div v-if="!loading">
        <v-container>
          <v-row class="d-flex align-center">
            <v-col class="shrink">
              <v-skeleton-loader type="avatar"></v-skeleton-loader>
            </v-col>
            <v-col class="grow">
              <v-skeleton-loader type="heading"></v-skeleton-loader>
            </v-col>
          </v-row>
          <v-row>
            <v-col v-for="n in 12" :key="n" cols="6">
              <v-skeleton-loader type="image"></v-skeleton-loader>
            </v-col>
          </v-row>
        </v-container>
      </div>
      <div v-else>
        <v-container>
          <v-row class="d-flex align-top">
            <v-col class="shrink pt-10">
              <img src="@/assets/logo.png" width="200px">
            </v-col>
            <v-col class="grow">
              <h1>{{ this.curriculum.fields.Name }}</h1>
              <p>{{ this.curriculum.fields.Description }}</p>
            </v-col>
          </v-row>
          <v-row 
            v-if="showError"
            class="d-flex justify-center"
          >
            <v-alert
              prominent
              type="error"
              elevation="3"
            >
              <strong>
                Cannot find an employee record with email: {{ user.email }}
              </strong>
              <v-spacer></v-spacer>
              You will be unable to sign up for sessions.
              This is most likely because your email in Ultipro does not match the
              email you use to login with Google.
              Please reach out to people@voxmedia.com for assistance.
            </v-alert>
          </v-row>
          <v-row v-if="pastSessions.length > 0">
            <v-col>
              <v-expansion-panels>
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    Past Sessions
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col
                        xl="6" lg="6" md="12" sm="12" xs="12"
                        v-for="session in pastSessions" :key="session.id"
                      >
                        <SessionSignupCard :session="session" />
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              xl="6" lg="6" md="12" sm="12" xs="12"
              v-for="session in upcomingSessions" :key="session.id"
            >
              <SessionSignupCard :session="session" />
            </v-col>
          </v-row>
        </v-container>
      </div>
    </v-container>
  </div>
</template>

<script>
  import ColorBanner from '@/components/Banner'
  import SessionSignupCard from '@/components/session/SignupCard'
  import User from '@/mixins/User'
  
  export default {
    name: 'PublicTrainingSignUp',
    mixins: [ User ],
    components: {
      ColorBanner,
      SessionSignupCard
    },
    data () {
      return {
        loadingRecords: true,
        // give us some time to see if we have an employee record
        // for this user before showing an alert
        createdTenSecondsAgo: false //TODO: as soon as you dont have a record, show the alert
      }
    },
    async created () {
      this.$store.dispatch('setUserEmployeeRecord')
      const curriculums = this.$store.dispatch('getRecords', {
        table: 'Curriculums',
        view: 'All Curriculums',
        dispatch: 'setCurriculums'
      })
      const sessions = this.$store.dispatch('getRecords', {
        table: 'Sessions',
        view: 'All Sessions',
        dispatch: 'setSessions'
      })
      Promise.all([curriculums, sessions])
      .then(() => {
        this.loadingRecords = false
      })
      setTimeout(() => {
        this.createdTenSecondsAgo = true
      }, 10000)
    },
    computed: {
      curriculum () {
        return this.$store.getters.getCurriculums.find(c => {
          return c.fields.URL === this.$route.params.slug
        })
      },
      loading () {
        return !this.loadingRecords && this.user
      },
      pastSessions () {
        if (!this.curriculum) return []
        return this.$store.getters.getSessions.filter(s => {
          return this.curriculum.fields.Sessions.includes(s.id) &&
                 !s.fields['Hide On Signup Page'] &&
                 new Date(s.fields.Start) < new Date() 
        })
      },
      showError () {
        return !this.userEmployeeRecord && this.createdTenSecondsAgo
      },
      upcomingSessions () {
        return this.$store.getters.getSessions.filter(s => {
          return this.curriculum.fields.Sessions.includes(s.id) &&
                 !s.fields['Hide On Signup Page'] &&
                 new Date(s.fields.Start) >= new Date()
        }).sort((a, b) => {
          return a.fields.Start > b.fields.Start ? 1 : -1
        })
      }
    }
  }
</script>
